import {
    Card,
    CardContent,
    Divider,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Container,
    FormControl,
    Dialog,
    DialogTitle,
    IconButton
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'


function KitchenCounterDrawer({
    visible,
    title,
    okText,
    onSubmit,
    onClose,
    initialValues,
    counterGroupData,
    outlet,
}) {

    if (initialValues == undefined)
        initialValues = {
            name: '',
            counter_group_id: '',
            printer_number: 0
        }

    if (outlet === undefined || outlet === null) {
        outlet = ""
    }

    if (counterGroupData == undefined) {
        counterGroupData = []
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Required'),
        counter_group_id: Yup.string().required('Required'),
        printer_number: Yup.number().required('Required'),
    })

    const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    return (
        <>
            <Dialog
                maxWidth="xs"
                fullWidth
                open={visible}
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                            setFieldValue
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider />
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={3} style={{ "paddingTop": "10px" }} columns={14}>
                                            <Grid item md={7}>
                                                <TextField
                                                    size='small'
                                                    name="name"
                                                    label="Name"
                                                    value={values.name}
                                                    margin="dense"
                                                    error={Boolean(touched.name && errors.name)}
                                                    helperText={touched.name && errors.name}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={3}
                                                />
                                            </Grid>
                                            <Grid item md={7}>
                                                <TextField
                                                    size='small'
                                                    name="printer_number"
                                                    label="Printer Number"
                                                    value={values.printer_number}
                                                    margin="dense"
                                                    error={Boolean(touched.printer_number && errors.printer_number)}
                                                    helperText={touched.printer_number && errors.printer_number}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    type="number"
                                                    my={3}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3} sx={{ marginTop: 2 }}>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="outlet"
                                                    id="outlet"
                                                    label="Outlet"
                                                    value={outlet}
                                                    error={Boolean(touched.outlet && errors.outlet)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    disabled
                                                    variant="outlined" />
                                            </Grid>
                                            <Grid item md={6}>
                                                <FormControl fullWidth sx={{ mt: 2 }} size="small" >
                                                    <InputLabel id="counter_group_select">Counter Group</InputLabel>
                                                    <Select
                                                        sx={{ maxHeight: 40 }}
                                                        label="Counter Group"
                                                        labelId="Counter-Group-label"
                                                        id="counter_group_select"
                                                        name="counter_group_id"
                                                        variant="outlined"
                                                        margin="dense"
                                                        fullWidth
                                                        value={values.counter_group_id}
                                                        error={Boolean(touched.counter_group_id && errors.counter_group_id)}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {counterGroupData.map((counter_group) => (
                                                            <MenuItem key={counter_group._id} value={counter_group._id}>
                                                                {counter_group.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item>
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </>
    )
}

export default KitchenCounterDrawer;